import Vue from 'vue'

// Sass
import '@/styles/main.scss'

// Post CSS
import 'postcss-object-fit-images'

// Pollyfills
import svg4everybody from 'svg4everybody'
import objectFitImages from 'object-fit-images'

// Hello World (Example Local Vue Component)
// import HelloWorld from '@/js/components/HelloWorld'
import NavHamburger from './components/main-nav/NavHamburger'
import NavLogo from './components/main-nav/NavLogo'
import NavBar from './components/main-nav/NavBar'
import NavMobileDrawer from './components/main-nav/NavMobileDrawer'
import NavMobileLink from './components/main-nav/NavMobileLink'
import NavLinkExpanded from './components/main-nav/NavLinkExpanded'
import NavLinkCollapse from './components/main-nav/NavLinkCollapse'
import NavDesktopLink from './components/main-nav/NavDesktopLink'
import NavDesktopLinkHover from './components/main-nav/NavDesktopLinkHover'
import NavDesktopExpanded from './components/main-nav/NavDesktopExpanded'
import NavSublink from './components/main-nav/NavSublink'
import NavSearch from './components/main-nav/NavSearch'
import NavSearchExpanded from './components/main-nav/NavSearchExpanded'
import TimelineCarousel from './components/TimelineCarousel'
import ProgressNum from './components/ProgressNum'
import ProgressBar from './components/ProgressBar'
import Counter from './components/Counter'
import Dropdown from './components/Dropdown'
import News from './components/News'
import SearchResults from './components/search/SearchResults'
import SearchForm from './components/search/SearchForm'
import SearchPagination from './components/search/SearchPagination'
import SearchAdvancedToggle from './components/search/SearchAdvancedToggle'
import SearchAdvancedForm from './components/search/SearchAdvancedForm'
import RandomFeatured from './components/RandomFeatured'
import SearchableGrid from './components/SearchableGrid'
import Accordion from './components/Accordion'
import TabContent from './components/TabContent'
import InterestExplorer from './components/InterestExplorer'
import EventIndex from './components/EventIndex'
import StoryIndex from './components/StoryIndex'
import PostPagination from './components/PostPagination'
import FormHero from './components/FormHero'
import HighContrast from './components/HighContrast'
import AccessibilityToggle from './components/AccessibilityToggle'
import PeopleGrid from './components/PeopleGrid'

import GlobalAnimations from './components/animation/GlobalAnimations'

// Intersection Observer Polyfill
import 'intersection-observer'

// Plugins
import ModalVideo from './components/modal-video/index'
import Carousel from './components/carousel/index'

Vue.config.productionTip = false

svg4everybody()
objectFitImages()

const Components = {
  // HelloWorld,
  NavHamburger,
  NavLogo,
  NavBar,
  NavMobileDrawer,
  NavMobileLink,
  NavLinkExpanded,
  NavLinkCollapse,
  NavSublink,
  NavDesktopLink,
  NavDesktopLinkHover,
  NavDesktopExpanded,
  NavSearch,
  NavSearchExpanded,
  TimelineCarousel,
  ProgressNum,
  ProgressBar,
  Counter,
  Dropdown,
  News,
  SearchResults,
  SearchForm,
  SearchPagination,
  SearchAdvancedToggle,
  SearchAdvancedForm,
  GlobalAnimations,
  RandomFeatured,
  SearchableGrid,
  Accordion,
  TabContent,
  InterestExplorer,
  EventIndex,
  StoryIndex,
  PostPagination,
  FormHero,
  HighContrast,
  AccessibilityToggle,
  PeopleGrid,
}

// Plugin Invocation
Vue.use(ModalVideo)
Vue.use(Carousel)

Object.keys(Components).forEach(componentName => {
  Vue.component(componentName, Components[componentName])
})

new Vue().$mount('#app')
